export enum SIGN_UP_INPUT_FIELD_ERROR {
  "MISSING" = "missing",
  "LESS_THAN_MINIMUM" = "less than minimum",
  "INVALID_VALUE" = "invalid value",
  "LARGER_THAN_MAXIMUM" = "larger than maximum",
}
